module.exports = __webpack_public_path__ + "img/logo.c55d94a6.png";